import { Observable } from 'rxjs';
import HttpFactory from './abstract.api.service';

interface CityData {
  readonly cityKompareId: string;
  readonly cityName: string;
  readonly cityParentName: string;
  readonly postalCode: number;
}

interface StreetData {
  readonly streetName: string
  readonly streetKompareId: string
  readonly cityKompareId: string
  readonly cityName: string
  readonly postalCode: number
}

export const apiRoutes: { [key: string]: string } = {
  addressSearch: `api/address-search/`,
  wordpressOperations: `api/wordpress-operations`
};

export class ApiService {
    static getCities(search: string): Observable<CityData[]> {
    const body = {
      operation: "search-cities",
      searchString: search,
      limit: 20
    }
    return HttpFactory.POST(apiRoutes.addressSearch, body);
  }

  static getStreets(search: string, cityKompareId?: string): Observable<StreetData[]> {
    const body = {
      operation: "search-streets",
      searchString: search,
      cityKompareId,
      limit: 20
    }
    return HttpFactory.POST(apiRoutes.addressSearch, body);
  }
}
